import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../Routes/AuthProvider";
import { AcceptApprovalRequest } from '../Services/ApprovalAPI';
import { RejectApprovalRequest } from '../Services/ApprovalAPI';

const BusApprovalDetail = ({ approvalDetails }) => {
    const navigate = useNavigate();
    const { name, userName, roles } = useContext(AuthContext);
    const [remark, setRemark] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);

    const booking = approvalDetails?.booking;
    const bp = approvalDetails?.bookingPoints;
    const fare = approvalDetails?.fares?.[0];
    const approval = approvalDetails?.requestedApprovals?.[0];

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";

        const date = new Date(dateStr);

        if (isNaN(date)) return "-";

        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const SubmitAcceptApprovalRequest = async (item) => {
        if (!item) {
            alert("Invalid approval data");
            return;
        }
        const { referenceNo, level1ApproverId, level1ApproverName, level1ApproverBy, level1ApproverEmail, level2ApproverId, level2ApproverName, level2ApproverBy, level2ApproverEmail, userId, product } = item;
        if (!referenceNo || !level1ApproverEmail) {
            alert("Missing required data");
            return;
        }
        setLoading(true);
        try {
            const requestBody = {
                referenceNo: referenceNo,
                level1ApproverEmail: level1ApproverEmail,
                level1Approver: level1ApproverId,
                level2ApproverEmail: level2ApproverEmail,
                level2Approver: level2ApproverId,
                product: "Bus",
                UserId: userName,
                ApprovalRequestedByUserName: userId,
                ApprovalRequestedByEmail: "",
                remark: remark
            };
            //console.log("requestBody:", requestBody);
            const data = await AcceptApprovalRequest(requestBody);
            if (data.message === "Booking Success" || data.message === "Booking Success") {
                if (data.productType === "Flight") {
                    navigate(`/thankyou?ReferenceNo=${referenceNo}`);
                } else {
                    navigate(`/bus/thankyou?ReferenceNo=${referenceNo}`);
                }
            } else {
                alert(data.message);
                navigate(`/approval`);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const SubmitRejectApprovalRequest = async (item) => {
        if (!item) {
            alert("Invalid approval data");
            return;
        }
        if (!remark) {
            alert("Remark Required");
            return;
        }
        const { referenceNo, level1ApproverId, level1ApproverName, level1ApproverBy, level1ApproverEmail, level2ApproverId, level2ApproverName, level2ApproverBy, level2ApproverEmail, userId, product } = item;
        if (!referenceNo || !level1ApproverEmail) {
            alert("Missing required data");
            return;
        }

        const modalElement = document.getElementById("myModal");
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        modalInstance.hide();
        setLoading(true);
        try {
            const requestBody = {
                referenceNo: referenceNo,
                level1ApproverEmail: level1ApproverEmail,
                level1Approver: level1ApproverId,
                level2ApproverEmail: level2ApproverEmail,
                level2Approver: level2ApproverId,
                product: "Bus",
                UserId: userName,
                ApprovalRequestedByUserName: userId,
                ApprovalRequestedByEmail: "",
                remark: remark
            };
            //console.log("requestBody:", requestBody);
            const data = await RejectApprovalRequest(requestBody);
            alert(data.message);
            window.location.reload();
            setRemark("");
            setSelectedItem(null);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const [timeLeft, setTimeLeft] = useState("");

    const getRemainingTime = (blockedOn) => {
        try {
            if (!blockedOn) return "Error";

            const blockTime = new Date(blockedOn);

            if (isNaN(blockTime)) return "Invalid Date";

            // Add 6 minutes
            const expiryTime = new Date(blockTime.getTime() + 6 * 60000);

            const diff = expiryTime - new Date();

            if (diff <= 0) return "Expired";

            const m = Math.floor(diff / 60000);
            const s = Math.floor((diff % 60000) / 1000);

            return `${m}m ${s}s left`;
        } catch (error) {
            return "Error";
        }
    };

    const blockedOn = approvalDetails?.booking?.blockedOn;
    useEffect(() => {
        if (!blockedOn) {
            setTimeLeft("No Time");
            return;
        }
        setTimeLeft(getRemainingTime(blockedOn));
        const interval = setInterval(() => {
            setTimeLeft(getRemainingTime(blockedOn));
        }, 1000);
        return () => clearInterval(interval);
    }, [blockedOn]);

    const formatDateTime = (dateStr) => {
        if (!dateStr) return "-";

        const date = new Date(dateStr);

        if (isNaN(date.getTime())) return "-";

        return date
            .toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
            })
            .replace(",", "")
            .replace("am", "AM")
            .replace("pm", "PM");
    };

    const getUserApprovalLevel = (approval, userName) => {
        const currentUserName = (userName || "").trim().toLowerCase();

        const level1Users = (approval.level1UserName || "")
            .split(";")
            .map(x => x.trim().toLowerCase())
            .filter(Boolean);

        const level2Users = (approval.level2UserName || "")
            .split(";")
            .map(x => x.trim().toLowerCase())
            .filter(Boolean);

        if (level1Users.includes(currentUserName)) {
            return 1;
        }

        if (level2Users.includes(currentUserName)) {
            return 2;
        }

        return 0;
    };
    return (
        <>
            <section className='wraper'>
                <div className='box_shadow mt-16'>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "10px 14px",
                            marginBottom: "15px",
                            borderRadius: "6px",
                            fontSize: "14px",
                            fontWeight: "500",
                            background: timeLeft === "Expired" ? "#f8d7da" : "#e7f3ff",
                            color: timeLeft === "Expired" ? "#842029" : "#084298",
                            borderLeft: `4px solid ${timeLeft === "Expired" ? "#dc3545" : "#0d6efd"}`,
                            zIndex: 10,
                            position: "relative"
                        }}
                    >
                        <span>⏳</span>
                        <span style={{ fontWeight: "600" }}>Booking Time:</span>
                        <span style={{ fontWeight: "700" }}>
                            {timeLeft === "Expired" ? "Session Expired" : timeLeft || "Calculating..."}
                        </span>
                    </div>
                    {/* Reason */}
                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className='headings'>Reason For Travel</h4>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Trip ID</div>
                                <div className="labl_detls">{approval?.referenceNo || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Travel Mode</div>
                                <div className="labl_detls">{booking.travelPurpose} Travel</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Employee ID</div>
                                <div className="labl_detls">{approval?.employeeId || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Employee Name</div>
                                <div className="labl_detls">{approval?.travellerName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Billing Entity</div>
                                <div className="labl_detls">{approvalDetails?.corporateDetails?.companyName || "-"}</div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className='headings'>Travel Info</h4>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">From City</div>
                                <div className="labl_detls">{booking?.sourceName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">To City</div>
                                <div className="labl_detls">{booking?.destinationName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Date Of Travel</div>
                                <div className="labl_detls">{formatDate(booking?.journeyDate)}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Operator</div>
                                <div className="labl_detls">{booking?.operatorName || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Bus Type</div>
                                <div className="labl_detls">{booking?.busType || "-"}</div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Total Fare</div>
                                <div className="labl_detls text-danger">
                                    ₹ {fare?.totalFare || 0}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Policy Status</div>
                                <div
                                    className="labl_detls"
                                    style={{
                                        color: booking?.policyStatus === "OutOfPolicy" ? "red" : "green",
                                        fontWeight: "600"
                                    }}
                                >
                                    {booking?.policyStatus || "-"}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Policy Reason</div>
                                <div className="labl_detls" style={{ color: "red" }}>{booking?.policyReason || "-"}</div>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className='headings'>Boarding & Dropping</h4>
                        </div>

                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Boarding Point</div>
                                <div className="labl_detls">{bp?.boardingPointLocation || "-"}</div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="d-flex mb-3">
                                <div className="labl">Dropping Point</div>
                                <div className="labl_detls">{bp?.droppingPointLocation || "-"}</div>
                            </div>
                        </div>
                    </div>

                    {approvalDetails && approvalDetails.passengers.length > 0 && (
                        <>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <h4 className='headings'>Passenger Details</h4>
                                </div>
                                {approvalDetails && approvalDetails.passengers && approvalDetails.passengers.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <div className='col-md-12'>
                                            <div class="d-flex mb-3">
                                                <div class="labl">Passenger Name </div>
                                                <div class="labl_detls">{item?.title} {item?.firstName} {item?.lastName}</div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </>
                    )}

                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="headings">Approvals</h4>
                        </div>

                        {/* ================= REQUEST ================= */}
                        <div className="col-md-12">
                            <div className="d-flex mb-3">
                                <div className="labl">Requested By</div>
                                <div className="labl_detls">
                                    {approval?.userId || "-"}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Submitted On</div>
                                <div className="labl_detls">
                                    {formatDateTime(approval?.createdOn)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Remark</div>
                                <div className="labl_detls">
                                    {approval?.remark || "-"}
                                </div>
                            </div>
                        </div>


                        {/* ================= LEVEL 1 ================= */}
                        <div className="col-md-12 mt-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className="mb-3">
                                    <span className="badge bg-secondary me-2">LEVEL 1</span>
                                    First Level Approval
                                </h5>

                                {/* <span
                className={`badge ${approval?.level1ApprovalStatus === "Accepted"
                  ? "bg-warning text-dark"
                  : approval?.level1ApprovalStatus === "Rejected"
                    ? "bg-danger"
                    : "bg-warning text-dark"
                  }`}
              >
                {approval?.level1ApprovalStatus || "Requested"}
              </span> */}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Approver(s)</div>
                                <div className="labl_detls">
                                    <span className="badge bg-light text-dark border">
                                        {approval?.level1ApproverName || "-"}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Action By</div>
                                <div className="labl_detls">
                                    {approval?.level1ActionBy || "-"}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Action On</div>
                                <div className="labl_detls">
                                    {formatDateTime(approval?.level1ActionOn)}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex mb-3">
                                <div className="labl">Status</div>
                                <div className="labl_detls">
                                    <span className="badge bg-warning text-dark">
                                        {approval?.level1ApprovalStatus || "Requested"}
                                    </span>
                                </div>
                            </div>
                        </div>


                        {/* ================= LEVEL 2 ================= */}
                        {approval?.level2ApproverName?.trim() && (
                            <>
                                <div className="col-md-12 mt-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h5 className="mb-3">
                                            <span className="badge bg-secondary me-2">LEVEL 2</span>
                                            Second Level Approval
                                        </h5>

                                        {/* <span className="badge bg-warning text-dark">
                {approval?.level2ApprovalStatus || "Requested"}
              </span> */}
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Approver(s)</div>
                                        <div className="labl_detls">
                                            {approval?.level2ApproverName ? (
                                                <span className="badge bg-light text-dark border">
                                                    {approval.level2ApproverName}
                                                </span>
                                            ) : (
                                                "-"
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Action By</div>
                                        <div className="labl_detls">
                                            {approval?.level2ActionBy || "-"}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Action On</div>
                                        <div className="labl_detls">
                                            {formatDateTime(approval?.level2ActionOn)}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="d-flex mb-3">
                                        <div className="labl">Status</div>
                                        <div className="labl_detls">
                                            <span className="badge bg-warning text-dark">
                                                {approval?.level2ApprovalStatus || "Requested"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    {/* {(
                        approval.level1ApprovalStatus === "Requested" ||
                        (
                            approval.level1ApprovalStatus === "Approved" &&
                            approval.level2ApprovalStatus === "Requested"
                        )
                    ) && (
                            <div className='text-end mt-3'>
                                <button
                                    className="btn btn-primary m-1"
                                    onClick={() => SubmitAcceptApprovalRequest(approval)}
                                >
                                    Approve
                                </button>
                                <button className='btn btn-primary m-1' data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => setSelectedItem(approvalDetails?.requestedApprovals?.[0])}>Reject</button>
                            </div>
                        )} */}

                    {(() => {
                        const approvalLevel = getUserApprovalLevel(approval, userName);

                        const currentStatus =
                            approvalLevel === 1
                                ? approval.level1ApprovalStatus
                                : approvalLevel === 2
                                    ? approval.level2ApprovalStatus
                                    : null;

                        return currentStatus === "Requested" && (
                            <div className="text-end mt-3">
                                <button
                                    type="button"
                                    className="btn btn-primary m-1"
                                    onClick={() => SubmitAcceptApprovalRequest(approval)}
                                >
                                    Approve
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary m-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#myModal"
                                    onClick={() =>
                                        setSelectedItem(
                                            approvalDetails?.requestedApprovals?.[0]
                                        )
                                    }
                                >
                                    Reject
                                </button>
                            </div>
                        );
                    })()}
                </div>
            </section>

            <div class="modal fade" id="myModal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Cancel Request</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body">
                            <div className='col-md-12'>
                                <label>Why Cancel ?</label>
                                <textarea className='form-controls' placeholder='Write Reason..' cols={80} rows={4}
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                ></textarea>
                            </div>
                            <div className='col-md-12 text-end'>
                                <button
                                    className="btn btn-danger"
                                    onClick={() =>
                                        SubmitRejectApprovalRequest(selectedItem)
                                    }
                                >
                                    Submit Request
                                </button>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default BusApprovalDetail